
import { useAppSelector } from '../../hooks';
import useTranslation from '../../hooks/useTranslation';
import { selectFieldStateByName } from '../../store/applicationform/applicationFormSelectors';
import ValidationErrorMessage from '../ValidationErrorMessage/ValidationErrorMessage';

type Props = {
    fieldName: string;
};

const ValidationError = ({ fieldName }: Props) => {
    const translate = useTranslation();
    const fieldState = useAppSelector(selectFieldStateByName)(fieldName);
    return (
        fieldState?.hasError && (
            <ValidationErrorMessage>
                {fieldState?.errorMessage && translate(fieldState?.errorMessage)}
            </ValidationErrorMessage>
        )
    );
};

export default ValidationError;
